export const ENABLE_QUOTES = 'SFT-187-enable-quotes';
export const ENABLE_QUOTES_BY_COUNTRY = 'SFT-515-enable-quotes-by-country';
